import { Component, OnDestroy, OnInit, inject, signal, viewChild } from '@angular/core';
import { faExclamationCircle, faWifi } from '@fortawesome/free-solid-svg-icons';
import { Subscription, filter } from 'rxjs';
import { WebsocketService } from 'app/foundation/service/websocket.service';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { NavigationEnd, Router } from '@angular/router';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { TranslateDirective } from 'app/foundation/language/translate.directive';
import { CloseCircleComponent } from '../close-circle/close-circle.component';
import { NgClass } from '@angular/common';

@Component({
    selector: 'jhi-connection-warning',
    templateUrl: './connection-warning.component.html',
    styleUrls: ['./connection-warning.component.scss'],
    imports: [FaIconComponent, TranslateDirective, CloseCircleComponent, NgClass, NgbPopover],
})
export class JhiConnectionWarningComponent implements OnInit, OnDestroy {
    private websocketService = inject(WebsocketService);
    private router = inject(Router);

    private readonly popoverRef = viewChild<NgbPopover>('popover');

    get popover(): NgbPopover {
        return this.popoverRef()!;
    }

    readonly disconnected = signal(false);
    readonly isOnExamParticipationPage = signal(false);
    websocketStatusSubscription?: Subscription;
    // Initialise with an empty Subscription so ngOnDestroy can unsubscribe safely even if the
    // constructor never assigned a real subscription (e.g. component torn down mid-construction).
    routerSubscription: Subscription = new Subscription();
    openTimeout?: ReturnType<typeof setTimeout>;

    // Icons
    faExclamationCircle = faExclamationCircle;
    faWifi = faWifi;

    constructor() {
        this.routerSubscription = this.router.events
            .pipe(filter((event) => event instanceof NavigationEnd))
            .subscribe((event: NavigationEnd) => this.isOnExamParticipationPage.set(!!event.url.match('^/courses/\\d+/exams/\\d+')));
    }

    ngOnInit() {
        this.websocketStatusSubscription = this.websocketService.connectionState.subscribe((status) => {
            this.disconnected.set(!status.connected && status.wasEverConnectedBefore);

            if (this.disconnected()) {
                this.openTimeout = setTimeout(() => this.popoverRef()?.open(), 300);
            } else {
                clearTimeout(this.openTimeout);
                this.popoverRef()?.close();
            }
        });
    }

    ngOnDestroy() {
        this.websocketStatusSubscription?.unsubscribe();
        this.routerSubscription.unsubscribe();
    }
}
